import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page49() {
  useEffect(() => {
    document.title = "Маяк — Страница 48"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page47" />
        <ForwardLink href="/page49" />
      </div>

      <p style={{ textAlign: "right" }}>48.</p>
      <p>Идет дождь. Дует ветер.</p>
      <p>Задержка.</p>
      <p>Начинается ливень.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>МОЛОДОЙ и СТАРИК сидят за столом совершенно неподвижно. Промокшие.</p>
      <p>Зажженая сигарета висит на нижней губе МОЛОДОГО.</p>
      <p>Шторм снаружи – это нечто библейское..</p>
      <p>Очень, очень длинная пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Они не пришли.
      </p>
      <p>Длинная пауза.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – НОЧЬ</p>
      <p>РАКУРС НА: Огромные волны разбиваются о берег.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. СКАЛЫ – НОЧЬ</p>
      <p>РАКУРС НА: Громадные волны разбиваются о скалы.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. СКАЛЫ – НОЧЬ</p>
      <p>Идет ливень. Потоп.</p>
      <p>
        СТАРИК в брезентовом плаще. Он стоит как волшебник перед<br/>
        ЛОДОЧНЫМ САРАЕМ, лицом к волнам. Он держит правую руку<br/>
        над морем, вытянув два пальца. В другой руке он<br/>
        держит бутылку.
      </p>
      <p>Он считает волны, когда они разбиваются о берег.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ...Четыре ...Пять ...Шесть
      </p>
      <p>Волны становятся все выше!</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        ...Семь ...Восемь ...Опуститесь!
      </p>
      <p>
        Он крестится (как католик) на девятой<br/>
        волне и ОБЛИВАЕТ МОРЕ ликером из бутылки.
      </p>
      <p style={{ textAlign: "right" }}>48.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page47" />
        <ForwardLink href="/page49" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710315479/the-lighthouse-script/mln4t0a7mvz1uaoqcxmt.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page49;
